import { __assign, __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { Message } from './FieldHint.styles';
import Tooltip from '../Tooltip';
var FieldHint = React.forwardRef(function (_a, ref) {
  var className = _a.className,
      _b = _a.variant,
      variant = _b === void 0 ? 'static' : _b,
      error = _a.error,
      disabled = _a.disabled,
      hideEmpty = _a.hideEmpty,
      tooltipPlacement = _a.tooltipPlacement,
      tooltipVariant = _a.tooltipVariant,
      message = _a.message,
      children = _a.children,
      props = __rest(_a, ["className", "variant", "error", "disabled", "hideEmpty", "tooltipPlacement", "tooltipVariant", "message", "children"]);

  if (hideEmpty && !message && variant !== 'tooltip') {
    return children;
  }

  var rootClassName = classnames(className, {
    error: error,
    disabled: disabled
  });

  if (variant === 'tooltip') {
    return _jsx(Tooltip, __assign({
      className: rootClassName,
      title: message,
      variant: tooltipVariant !== null && tooltipVariant !== void 0 ? tooltipVariant : error ? 'negative' : 'primary',
      placement: tooltipPlacement,
      disableFocusListener: false
    }, {
      children: children
    }));
  }

  return _jsxs(_Fragment, {
    children: [children, _jsx(Message, __assign({
      className: rootClassName,
      ref: ref
    }, props, {
      children: message
    }))]
  });
});
export default React.memo(FieldHint);